// src/shared/components/ErrorBoundary.tsx
import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { Button } from '@shared/components/ui/button/Button.tsx';

const ErrorFallback: React.FC<{ error: Error; resetErrorBoundary: () => void }> = ({
    error,
    resetErrorBoundary,
}) => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-mp-background">
            <div className="max-w-md w-full bg-mp-surface shadow-lg rounded-lg p-6">
                <div className="text-center">
                    <h2 className="text-2xl font-bold text-mp-error mb-4">
                        Something went wrong
                    </h2>
                    <p className="text-mp-muted mb-6">{error.message}</p>
                    <Button onClick={resetErrorBoundary}>
                        Try again
                    </Button>
                </div>
            </div>
        </div>
    );
};

export const ErrorBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <ReactErrorBoundary
            FallbackComponent={ErrorFallback}
            onError={(error, errorInfo) => {
                console.error('Error caught by boundary:', error, errorInfo);
                // You can send to error reporting service here
            }}
        >
            {children}
        </ReactErrorBoundary>
    );
};
